export interface CustomDetailEvent<T = unknown> extends Event {
  detail: {
    event: Events
    source: Sources
    data?: T
  }
}

export enum Channels {
  UI = 'ui',
  AUTH = 'auth',
  SEARCH = 'search',
  ENTITY = 'entity',
}

export enum Sources {
  LEGACY = 'legacy',
  NAV = 'nav',
  LOGIN = 'login',
  ORG = 'org',
  RANKINGS = 'rankings',
}

export enum Events {
  SIDE_PANEL_SHOW = 'sidePanelShow',
  SIDE_PANEL_HIDE = 'sidePanelHide',
  SIDE_PANEL_EXPAND = 'sidePanelExpand',
  SIDE_PANEL_COLLAPSE = 'sidePanelCollapse',
  USER_AUTHENTICATED = 'userAuthenticated',
  USER_UNAUTHENTICATED = 'userUnauthenticated',
  SEARCH_TERM_CHANGE = 'searchTermChange',
  SEARCH_TERM_RESET = 'searchTermReset',
  TOGGLE_CLAIM = 'toggleClaim',
  LOGOUT = 'logout',
  SET_INCOMING_QUEUE = 'setIncomingQueue',
  SET_INCOMING_ENTITY = 'setIncomingEntity',
  SET_INCOMING_FILTER = 'setIncomingFilter',
}

export const dispatch = (
  channel: Channels,
  source: Sources,
  event: Events,
  data?: unknown,
) => {
  const customEvent = new CustomEvent(channel, {
    detail: { event, source, data },
  })
  window.dispatchEvent(customEvent)
}

export const listen = (
  channel: Channels,
  callback: (event: CustomDetailEvent) => void,
) => {
  window.addEventListener(channel, callback)

  return () => {
    window.removeEventListener(channel, callback)
  }
}
